// extracted by mini-css-extract-plugin
module.exports = {"root":"Tabs_root__17Jur","tab":"Tabs_tab__2Npnx","tabActive":"Tabs_tabActive__37ZQi"};